import { isMobile } from '../helpers/isMobile';

export const applicationsId = {
  225: {
    production: '149',
    development: '236',
  },
  226: {
    production: '150',
    development: '237',
  },
  227: {
    production: '151',
    development: '238',
  },
  329: {
    production: '226',
    development: '313',
  },
};

export const gameNameById = {
  225: 'superBlaze20',
  226: 'superBlaze40',
  227: 'superBlaze100',
  329: 'betPlaySuperBlaze40',
};

export const googleAnalyticsTokensByGame = {
  225: 'GTM-PC9MRRKF',
  226: 'GTM-TNTSMJ2M',
  227: 'GTM-KLSC7WD8',
  329: 'GTM-KQKK7CHW',
};

export const matricesByGameId = {
  225: {
    WinningLinesCoordinate: [
      [
        { x: 1, y: 0 },
        { x: 1, y: 1 },
        { x: 1, y: 2 },
        { x: 1, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 0, y: 1 },
        { x: 0, y: 2 },
        { x: 0, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 2, y: 1 },
        { x: 2, y: 2 },
        { x: 2, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 1, y: 1 },
        { x: 2, y: 2 },
        { x: 1, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 1, y: 1 },
        { x: 0, y: 2 },
        { x: 1, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 0, y: 1 },
        { x: 1, y: 2 },
        { x: 2, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 2, y: 1 },
        { x: 1, y: 2 },
        { x: 0, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 2, y: 1 },
        { x: 2, y: 2 },
        { x: 2, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 0, y: 1 },
        { x: 0, y: 2 },
        { x: 0, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 1, y: 1 },
        { x: 1, y: 2 },
        { x: 1, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 1, y: 1 },
        { x: 1, y: 2 },
        { x: 1, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 2, y: 1 },
        { x: 1, y: 2 },
        { x: 0, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 0, y: 1 },
        { x: 1, y: 2 },
        { x: 2, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 1, y: 1 },
        { x: 0, y: 2 },
        { x: 1, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 1, y: 1 },
        { x: 2, y: 2 },
        { x: 1, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 1, y: 1 },
        { x: 2, y: 2 },
        { x: 1, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 1, y: 1 },
        { x: 0, y: 2 },
        { x: 1, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 2, y: 1 },
        { x: 0, y: 2 },
        { x: 2, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 0, y: 1 },
        { x: 2, y: 2 },
        { x: 0, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 0, y: 1 },
        { x: 2, y: 2 },
        { x: 0, y: 3 },
        { x: 1, y: 4 },
      ],
    ],
    allLineMatrix: [
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
    ],
    symbolsMatrix: [
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
    ],
  },
  226: {
    WinningLinesCoordinate: [
      [
        { x: 1, y: 0 },
        { x: 1, y: 1 },
        { x: 1, y: 2 },
        { x: 1, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 2, y: 1 },
        { x: 2, y: 2 },
        { x: 2, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 0, y: 1 },
        { x: 0, y: 2 },
        { x: 0, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 3, y: 1 },
        { x: 3, y: 2 },
        { x: 3, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 2, y: 1 },
        { x: 3, y: 2 },
        { x: 2, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 1, y: 1 },
        { x: 0, y: 2 },
        { x: 1, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 0, y: 1 },
        { x: 1, y: 2 },
        { x: 2, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 3, y: 1 },
        { x: 2, y: 2 },
        { x: 1, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 3, y: 1 },
        { x: 3, y: 2 },
        { x: 3, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 0, y: 1 },
        { x: 0, y: 2 },
        { x: 0, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 1, y: 1 },
        { x: 2, y: 2 },
        { x: 3, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 2, y: 1 },
        { x: 1, y: 2 },
        { x: 0, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 0, y: 1 },
        { x: 1, y: 2 },
        { x: 2, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 3, y: 1 },
        { x: 2, y: 2 },
        { x: 1, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 1, y: 1 },
        { x: 0, y: 2 },
        { x: 1, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 2, y: 1 },
        { x: 3, y: 2 },
        { x: 2, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 2, y: 1 },
        { x: 1, y: 2 },
        { x: 0, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 1, y: 1 },
        { x: 2, y: 2 },
        { x: 3, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 1, y: 1 },
        { x: 1, y: 2 },
        { x: 1, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 2, y: 1 },
        { x: 2, y: 2 },
        { x: 2, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 1, y: 1 },
        { x: 2, y: 2 },
        { x: 3, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 2, y: 1 },
        { x: 1, y: 2 },
        { x: 0, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 1, y: 1 },
        { x: 2, y: 2 },
        { x: 2, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 2, y: 1 },
        { x: 1, y: 2 },
        { x: 1, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 2, y: 1 },
        { x: 2, y: 2 },
        { x: 2, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 1, y: 1 },
        { x: 1, y: 2 },
        { x: 1, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 0, y: 1 },
        { x: 1, y: 2 },
        { x: 0, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 3, y: 1 },
        { x: 2, y: 2 },
        { x: 3, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 2, y: 1 },
        { x: 3, y: 2 },
        { x: 2, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 1, y: 1 },
        { x: 0, y: 2 },
        { x: 1, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 0, y: 1 },
        { x: 0, y: 2 },
        { x: 1, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 3, y: 1 },
        { x: 3, y: 2 },
        { x: 2, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 3, y: 1 },
        { x: 3, y: 2 },
        { x: 2, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 0, y: 1 },
        { x: 0, y: 2 },
        { x: 1, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 1, y: 1 },
        { x: 1, y: 2 },
        { x: 2, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 2, y: 1 },
        { x: 2, y: 2 },
        { x: 1, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 3, y: 1 },
        { x: 2, y: 2 },
        { x: 1, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 0, y: 1 },
        { x: 1, y: 2 },
        { x: 2, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 1, y: 1 },
        { x: 2, y: 2 },
        { x: 3, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 2, y: 1 },
        { x: 1, y: 2 },
        { x: 0, y: 3 },
        { x: 1, y: 4 },
      ],
    ],
    allLineMatrix: [
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
    ],
    symbolsMatrix: [
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
    ],
  },
  227: {
    WinningLinesCoordinate: [
      [
        { x: 1, y: 0 },
        { x: 1, y: 1 },
        { x: 1, y: 2 },
        { x: 1, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 2, y: 1 },
        { x: 2, y: 2 },
        { x: 2, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 0, y: 1 },
        { x: 0, y: 2 },
        { x: 0, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 3, y: 1 },
        { x: 3, y: 2 },
        { x: 3, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 3, y: 1 },
        { x: 3, y: 2 },
        { x: 3, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 0, y: 1 },
        { x: 0, y: 2 },
        { x: 0, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 1, y: 1 },
        { x: 1, y: 2 },
        { x: 1, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 2, y: 1 },
        { x: 2, y: 2 },
        { x: 2, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 3, y: 1 },
        { x: 2, y: 2 },
        { x: 3, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 0, y: 1 },
        { x: 1, y: 2 },
        { x: 0, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 1, y: 1 },
        { x: 0, y: 2 },
        { x: 1, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 2, y: 1 },
        { x: 3, y: 2 },
        { x: 2, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 3, y: 1 },
        { x: 1, y: 2 },
        { x: 3, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 0, y: 1 },
        { x: 2, y: 2 },
        { x: 0, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 2, y: 1 },
        { x: 0, y: 2 },
        { x: 2, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 1, y: 1 },
        { x: 3, y: 2 },
        { x: 1, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 0, y: 1 },
        { x: 1, y: 2 },
        { x: 0, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 3, y: 1 },
        { x: 2, y: 2 },
        { x: 3, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 2, y: 1 },
        { x: 3, y: 2 },
        { x: 2, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 1, y: 1 },
        { x: 0, y: 2 },
        { x: 1, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 3, y: 1 },
        { x: 0, y: 2 },
        { x: 3, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 0, y: 1 },
        { x: 3, y: 2 },
        { x: 0, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 2, y: 1 },
        { x: 1, y: 2 },
        { x: 2, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 1, y: 1 },
        { x: 2, y: 2 },
        { x: 1, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 1, y: 1 },
        { x: 2, y: 2 },
        { x: 2, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 2, y: 1 },
        { x: 1, y: 2 },
        { x: 1, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 3, y: 1 },
        { x: 3, y: 2 },
        { x: 3, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 0, y: 1 },
        { x: 0, y: 2 },
        { x: 0, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 2, y: 1 },
        { x: 3, y: 2 },
        { x: 1, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 1, y: 1 },
        { x: 0, y: 2 },
        { x: 2, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 3, y: 1 },
        { x: 2, y: 2 },
        { x: 0, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 0, y: 1 },
        { x: 1, y: 2 },
        { x: 3, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 1, y: 1 },
        { x: 2, y: 2 },
        { x: 1, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 2, y: 1 },
        { x: 1, y: 2 },
        { x: 2, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 3, y: 1 },
        { x: 0, y: 2 },
        { x: 3, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 0, y: 1 },
        { x: 3, y: 2 },
        { x: 0, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 2, y: 1 },
        { x: 2, y: 2 },
        { x: 3, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 1, y: 1 },
        { x: 1, y: 2 },
        { x: 0, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 0, y: 1 },
        { x: 3, y: 2 },
        { x: 1, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 3, y: 1 },
        { x: 0, y: 2 },
        { x: 2, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 1, y: 1 },
        { x: 3, y: 2 },
        { x: 0, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 2, y: 1 },
        { x: 0, y: 2 },
        { x: 3, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 0, y: 1 },
        { x: 2, y: 2 },
        { x: 1, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 3, y: 1 },
        { x: 1, y: 2 },
        { x: 2, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 2, y: 1 },
        { x: 0, y: 2 },
        { x: 1, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 1, y: 1 },
        { x: 3, y: 2 },
        { x: 2, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 3, y: 1 },
        { x: 2, y: 2 },
        { x: 3, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 0, y: 1 },
        { x: 1, y: 2 },
        { x: 0, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 1, y: 1 },
        { x: 2, y: 2 },
        { x: 3, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 2, y: 1 },
        { x: 1, y: 2 },
        { x: 0, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 3, y: 1 },
        { x: 3, y: 2 },
        { x: 2, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 0, y: 1 },
        { x: 0, y: 2 },
        { x: 1, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 3, y: 1 },
        { x: 1, y: 2 },
        { x: 2, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 0, y: 1 },
        { x: 2, y: 2 },
        { x: 1, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 2, y: 1 },
        { x: 0, y: 2 },
        { x: 3, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 1, y: 1 },
        { x: 3, y: 2 },
        { x: 0, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 0, y: 1 },
        { x: 1, y: 2 },
        { x: 2, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 3, y: 1 },
        { x: 2, y: 2 },
        { x: 1, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 2, y: 1 },
        { x: 3, y: 2 },
        { x: 0, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 1, y: 1 },
        { x: 0, y: 2 },
        { x: 3, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 1, y: 1 },
        { x: 2, y: 2 },
        { x: 0, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 2, y: 1 },
        { x: 1, y: 2 },
        { x: 3, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 1, y: 1 },
        { x: 3, y: 2 },
        { x: 2, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 2, y: 1 },
        { x: 0, y: 2 },
        { x: 1, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 1, y: 1 },
        { x: 2, y: 2 },
        { x: 3, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 2, y: 1 },
        { x: 1, y: 2 },
        { x: 0, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 3, y: 1 },
        { x: 0, y: 2 },
        { x: 1, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 0, y: 1 },
        { x: 3, y: 2 },
        { x: 2, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 3, y: 1 },
        { x: 2, y: 2 },
        { x: 1, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 0, y: 1 },
        { x: 1, y: 2 },
        { x: 2, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 0, y: 1 },
        { x: 2, y: 2 },
        { x: 3, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 3, y: 1 },
        { x: 1, y: 2 },
        { x: 0, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 1, y: 1 },
        { x: 3, y: 2 },
        { x: 2, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 2, y: 1 },
        { x: 0, y: 2 },
        { x: 1, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 2, y: 1 },
        { x: 1, y: 2 },
        { x: 3, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 1, y: 1 },
        { x: 2, y: 2 },
        { x: 0, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 2, y: 1 },
        { x: 2, y: 2 },
        { x: 3, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 1, y: 1 },
        { x: 1, y: 2 },
        { x: 0, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 3, y: 1 },
        { x: 3, y: 2 },
        { x: 1, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 0, y: 1 },
        { x: 0, y: 2 },
        { x: 2, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 2, y: 1 },
        { x: 3, y: 2 },
        { x: 3, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 1, y: 1 },
        { x: 0, y: 2 },
        { x: 0, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 3, y: 1 },
        { x: 0, y: 2 },
        { x: 2, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 0, y: 1 },
        { x: 3, y: 2 },
        { x: 1, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 3, y: 1 },
        { x: 0, y: 2 },
        { x: 2, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 0, y: 1 },
        { x: 3, y: 2 },
        { x: 1, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 3, y: 1 },
        { x: 1, y: 2 },
        { x: 0, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 0, y: 1 },
        { x: 2, y: 2 },
        { x: 3, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 3, y: 1 },
        { x: 1, y: 2 },
        { x: 2, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 0, y: 1 },
        { x: 2, y: 2 },
        { x: 1, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 2, y: 1 },
        { x: 3, y: 2 },
        { x: 3, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 1, y: 1 },
        { x: 0, y: 2 },
        { x: 0, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 2, y: 1 },
        { x: 1, y: 2 },
        { x: 0, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 1, y: 1 },
        { x: 2, y: 2 },
        { x: 3, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 3, y: 1 },
        { x: 3, y: 2 },
        { x: 1, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 0, y: 1 },
        { x: 0, y: 2 },
        { x: 2, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 3, y: 1 },
        { x: 2, y: 2 },
        { x: 1, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 0, y: 1 },
        { x: 1, y: 2 },
        { x: 2, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 2, y: 1 },
        { x: 0, y: 2 },
        { x: 0, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 1, y: 1 },
        { x: 3, y: 2 },
        { x: 3, y: 3 },
        { x: 0, y: 4 },
      ],
    ],
    allLineMatrix: [
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
    ],
    symbolsMatrix: [
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
    ],
  },
  329: {
    WinningLinesCoordinate: [
      [
        { x: 1, y: 0 },
        { x: 1, y: 1 },
        { x: 1, y: 2 },
        { x: 1, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 2, y: 1 },
        { x: 2, y: 2 },
        { x: 2, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 0, y: 1 },
        { x: 0, y: 2 },
        { x: 0, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 3, y: 1 },
        { x: 3, y: 2 },
        { x: 3, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 2, y: 1 },
        { x: 3, y: 2 },
        { x: 2, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 1, y: 1 },
        { x: 0, y: 2 },
        { x: 1, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 0, y: 1 },
        { x: 1, y: 2 },
        { x: 2, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 3, y: 1 },
        { x: 2, y: 2 },
        { x: 1, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 3, y: 1 },
        { x: 3, y: 2 },
        { x: 3, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 0, y: 1 },
        { x: 0, y: 2 },
        { x: 0, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 1, y: 1 },
        { x: 2, y: 2 },
        { x: 3, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 2, y: 1 },
        { x: 1, y: 2 },
        { x: 0, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 0, y: 1 },
        { x: 1, y: 2 },
        { x: 2, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 3, y: 1 },
        { x: 2, y: 2 },
        { x: 1, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 1, y: 1 },
        { x: 0, y: 2 },
        { x: 1, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 2, y: 1 },
        { x: 3, y: 2 },
        { x: 2, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 2, y: 1 },
        { x: 1, y: 2 },
        { x: 0, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 1, y: 1 },
        { x: 2, y: 2 },
        { x: 3, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 1, y: 1 },
        { x: 1, y: 2 },
        { x: 1, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 2, y: 1 },
        { x: 2, y: 2 },
        { x: 2, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 1, y: 1 },
        { x: 2, y: 2 },
        { x: 3, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 2, y: 1 },
        { x: 1, y: 2 },
        { x: 0, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 1, y: 1 },
        { x: 2, y: 2 },
        { x: 2, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 2, y: 1 },
        { x: 1, y: 2 },
        { x: 1, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 2, y: 1 },
        { x: 2, y: 2 },
        { x: 2, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 1, y: 1 },
        { x: 1, y: 2 },
        { x: 1, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 0, y: 1 },
        { x: 1, y: 2 },
        { x: 0, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 3, y: 1 },
        { x: 2, y: 2 },
        { x: 3, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 2, y: 1 },
        { x: 3, y: 2 },
        { x: 2, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 1, y: 1 },
        { x: 0, y: 2 },
        { x: 1, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 0, y: 1 },
        { x: 0, y: 2 },
        { x: 1, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 3, y: 1 },
        { x: 3, y: 2 },
        { x: 2, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 3, y: 1 },
        { x: 3, y: 2 },
        { x: 2, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 0, y: 1 },
        { x: 0, y: 2 },
        { x: 1, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 1, y: 1 },
        { x: 1, y: 2 },
        { x: 2, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 2, y: 1 },
        { x: 2, y: 2 },
        { x: 1, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 3, y: 1 },
        { x: 2, y: 2 },
        { x: 1, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 0, y: 1 },
        { x: 1, y: 2 },
        { x: 2, y: 3 },
        { x: 3, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 1, y: 1 },
        { x: 2, y: 2 },
        { x: 3, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 3, y: 0 },
        { x: 2, y: 1 },
        { x: 1, y: 2 },
        { x: 0, y: 3 },
        { x: 1, y: 4 },
      ],
    ],
    allLineMatrix: [
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
    ],
    symbolsMatrix: [
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
    ],
  },
};

export const winPopupConfigs = {
  popupPosition: {
    x: isMobile() ? 20 : 720,
    y: isMobile() ? 480 : 350,
  },
  amountConfigs: {
    type: 'text',
    x: 0,
    y: -15,
    fontChangeLimit: 8,
    style: {
      _fontFamily: 'rockwell',
      _fontWeight: 'bold',
      _wordWrap: true,
      _fill: ['#FFD700', '#FF9F00'],
      stroke: '#D20000',
      strokeThickness: isMobile() ? 10 : 16,
      dropShadow: true,
      dropShadowAngle: Math.PI / 2,
      dropShadowBlur: 0,
      dropShadowDistance: isMobile() ? 10 : 16,
      dropShadowColor: '#CB5407',
      padding: 4,
    },
    fontSizeBig: isMobile() ? 180 : 240,
    fontSizeSmall: isMobile() ? 160 : 220,

  },
  animationConfigs: {
    oddsLimit: {
      big: 15,
      mega: 21,
      super: 101,
      epic: 201,
    },
    winPopupAnimation: [
      {
        type: 'BIG',
        duration: 3000,
        animationNames: ['bigStart', 'bigLoop'],
      },
      {
        type: 'MEGA',
        duration: 4000,
        animationNames: ['bigStart', 'bigLoop', 'megaChange', 'megaLoop'],
      },
      {
        type: 'SUPER',
        duration: 5000,
        animationNames: [
          'bigStart',
          'bigLoop',
          'megaChange',
          'megaLoop',
          'superChange',
          'superLoop',
        ],
      },
      {
        type: 'EPIC',
        duration: 12000,
        animationNames: [
          'bigStart',
          'bigLoop',
          'megaChange',
          'megaLoop',
          'superChange',
          'superLoop',
          'epicChange',
          'epicLoop',
        ],
      },
    ],
    winPopupShownMinOdd: 15,
  },
};
